import React from 'react';
import {
  ContentGrid,
  DocsContent,
  ParagraphText,
  TableOfContentsWrapper,
} from '../../styles';
import { MarkdownDoc } from '../../../Markdown';
import { useMarkdownDoc } from '../../hooks/useMarkdownDoc';

export function ServiceManagementApiTabContent() {
  const { markdown, isLoading, hasError } = useMarkdownDoc(
    '/docs/service-management-api/overview.md',
  );

  return (
    <ContentGrid>
      <DocsContent>
        {isLoading ? <ParagraphText>Loading article...</ParagraphText> : null}

        {hasError ? (
          <ParagraphText>
            Unable to load this article. Please try again later.
          </ParagraphText>
        ) : null}

        {markdown ? <MarkdownDoc markdown={markdown} variant="tab" /> : null}
      </DocsContent>

      <TableOfContentsWrapper aria-hidden />
    </ContentGrid>
  );
}
